export const PROVINCE_ERROR_MESSAGE = 'Province is required';

export const CITY_ERROR_MESSAGE = 'City is required';

export const SOLD_PERIOD_MESSAGE = 'Sold period is required';

export const DATE_RANGE_MESSAGE = 'Transaction date is required';

export const PROPERTY_TYPE_MESSAGE = 'Property type is required';

export const PROPERTY_STYLE_MESSAGE = 'Property style is required';

export const YEAR_BUILT_MESSAGE = 'Year built is required';

export const SQFT_ERROR_MESSAGE = 'SqFt is required';
